import React from 'react'
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styled from 'styled-components'

const CentedDiv = styled.div`
top: 35%; 
position: relative;
`

export default function UpgradePlan({ inverted }) {
    const { t } = useTranslation();

    return (
        <div className="text-center h-100 w-100">
            <CentedDiv id="plan" name="plan" className={clsx('upgrade-plan', inverted && 'text-white')}>
                <h2>{t('wordList.plans.upgrade')}</h2>
                <p>{t('wordList.plans.availableOnPE')}</p>
                <p className="know-more">{t('wordList.plans.knowmore')}</p>
                <a className={clsx('btn btn-sm', inverted ? 'btn-primary' : 'btn-white')} href="https://trato.io#plans" target="_blank" rel="noreferrer">{t('wordList.plans.see_plans')}</a>
            </CentedDiv>
            <div id="blur" name="blur" />
        </div>

    )
}